/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_No_AccountInputs */



/**
* | output |
* | --- |
* | "(no account)" |
*
* @param {Players_No_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_no_account = /** @type {((inputs?: Players_No_AccountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_No_AccountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("(pas de compte)")
	if (locale === "es") return /** @type {LocalizedString} */ ("(sin cuenta)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("(sem conta)")
	if (locale === "it") return /** @type {LocalizedString} */ ("(nessun account)")
	return /** @type {LocalizedString} */ ("(no account)")
});